import base from '@/__vue2stone/service/wasaapi/v1/__base';
import store from '@/store';

export default {
  async actIndex(factoryId, params) {
    //取得record內容
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'act',
      params: _params,
      pagination: true,
    });
    return res;
  },
  async actIndexAll(factoryId, params) {
    //取得record內容
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'act/index/all',
      params: _params,
      pagination: true,
    });
    return res;
  },
  async myactIndex(factoryId, params) {
    //取得record內容
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'myact',
      params: _params,
      pagination: true,
    });
    return res;
  },
  async actShow(factoryId, actId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.show({
      url: `factory/${factoryId}/act/${actId}`,
      params: _params,
    });
    return res;
  },
  async collect(actId, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.create({
      url: `collect/act/${actId}`,
      data: _data,
    });
    return res;
  },
  async unCollect(actId, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.create({
      url: `uncollect/act/${actId}`,
      data: _data,
    });
    return res;
  },
  async getChangeExportPdf(factoryId, params) {
    const {id, timezone} = store.state.app.factory;
    const _params = {
      factory: id,
      timezone,
      ...params,
    };
    const res = await base.show({
      url: `factory/${factoryId}/act/get_change_export_pdf_url`,
      params: _params,
    });
    return res;
  },
  async excelExport(factoryId, params) {
    const {id, timezone} = store.state.app.factory;
    const _params = {
      factory: id,
      timezone,
      ...params,
    };
    const res = await base.show({
      url: `factory/${factoryId}/act/export/excel`,
      params: _params,
    });
    return res;
  },
  async getExportPdf(factoryId, params) {
    const {id, timezone} = store.state.app.factory;
    const _params = {
      factory: id,
      timezone,
      ...params,
    };
    const res = await base.show({
      url: `factory/${factoryId}/act/export/library/pdf`,
      params: _params,
    });
    return res;
  },
  async updateTag(factoryId, actId, data) {
    //取得record內容
    const res = await base.update({
      url: `factory/${factoryId}/act/${actId}/update/factory_tags`,
      data,
    });
    return res;
  },
};
